import * as React from 'react';
import { CSSProperties } from 'react';
import * as Tgcc from '../../tgccGlobal'
import { ShopCloseX } from './ShopCloseX';

const wrapperStyle: CSSProperties = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: '#a9a9a9A1',
    zIndex: 800
}
const popupStyle: CSSProperties = {
    zIndex: 900,
    position: 'fixed',
    top: '50%',
    left: '50%',
    marginRight: '-50%',
    height: '80vh',
    transform: 'translate(-50%, -50%)',
}
const imgStyle: CSSProperties = {
    height: '100%',
    width: '100%',
}

type Props = {
    proofId: string,
    clearStateCallback: (evt: any) => void
}

export class ShopItemCloseUp extends React.Component<Props, any>{
    render() {
        var imgPath = Tgcc.getProofPath(this.props.proofId);
        return (
            <div style={wrapperStyle} onClick={this.props.clearStateCallback}>
                <div style={popupStyle} className="webstorePopUp">
                    <ShopCloseX closeAction={this.props.clearStateCallback} position='absolute' right='3px' top='-4px' />
                    <img style={imgStyle} src={imgPath} />
                </div>
            </div>
        )
    }
}

